import { render, staticRenderFns } from "./CreateMenuItemFromPages.vue?vue&type=template&id=0c149eda&"
import script from "./CreateMenuItemFromPages.vue?vue&type=script&lang=js&"
export * from "./CreateMenuItemFromPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports